import { cx } from './cx'

/** Inline loading indicator. `currentColor`, so it inherits the button's text colour. */
export default function Spinner({ className }: { className?: string }) {
  return (
    <svg
      className={cx('animate-spin shrink-0', className ?? 'w-4 h-4')}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" opacity="0.25" />
      <path
        d="M22 12a10 10 0 0 1-10 10"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  )
}
